// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"349":"70323e5a","623":"561f75b1","902":"7af1f185"}[chunkId] + ".chunk.css";
};